import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { prepareAppsInTossHost } from "./platform/apps-in-toss";
import { recordVisit } from "./platform/analytics";
import "./styles/app.css";

async function start() {
  await prepareAppsInTossHost();
  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

void start();

if (import.meta.env.PROD) void recordVisit();

if (import.meta.env.PROD && "serviceWorker" in navigator) {
  window.addEventListener("load", () => navigator.serviceWorker.register("/sw.js").catch(() => undefined));
}
